/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { Banner } from 'commons/models/banner.model';
import { UserlistData } from './constants';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getBannersData = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: any;
			app: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/banner/getAllBanners',
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				}
			});
			let data = _get(result, ['data', 'banners'], []);
			data = _map(data, (row) => {
				const newRow = row;
				if (newRow?.cta) {
					newRow.ctaType = newRow.cta?.type;
					newRow.ctaValue = newRow.cta?.value;
					if (newRow.cta?.params?.gameName) {
						newRow.ctaParamsGameName = newRow.cta.params.gameName;
					}
					delete newRow.cta;
				}
				return newRow;
			});
			const rowCount = _get(result, ['data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData };
		},
		[]
	);

	const requestCreateBanner = useCallback((appName: string, data: Banner) => {
		return postData({
			endpoint: '/marketing/dashboard/banner/addBanners',
			body: { banners: [data], isGold: data.isGold },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateBanner = useCallback((appName: string, data: Banner) => {
		return postData({
			endpoint: '/marketing/dashboard/banner/updateBannerStatus',
			body: { banners: [data], isGold: data.isGold },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestCreateUserSegment = useCallback((appName: string, data: UserlistData) => {
		const { uids, bannerId } = data;
		const formData = new FormData();
		formData.append('attachment', uids);
		formData.append('bannerId', bannerId);

		return postData({
			endpoint: '/marketing/dashboard/banner/createUserSegment',
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },
			queryParams: {
				appName
			}
		});
	}, []);
	const toggleIsActiveField = useCallback(async (rowData: any, history: any, user: any, app: any, showAlert: any) => {
		const data = { ...rowData };
		data.isActive = !data.isActive;
		data.cta = {
			type: data.ctaType,

			value: data.ctaValue
		};
		delete data.ctaType;
		delete data.ctaValue;
		delete data.id;

		try {
			const response = await requestUpdateBanner(app.appName, data);
			if (response.status !== 200 || !response.data.success) {
				showAlert(response.data.error || 'Error occured while updated', { type: 'error' });
				return;
			}
			// eslint-disable-next-line no-param-reassign
			rowData.isActive = data.isActive;
			showAlert(data.isActive ? 'The banner is deployed now' : 'The banner is removed from the app');
		} catch (error: any) {
			showAlert(error.response.data.error || 'Error occured while updated', { type: 'error' });
		}
	}, []);

	return {
		getBannersData,
		requestCreateUserSegment,
		requestUpdateBanner,
		requestCreateBanner,
		toggleIsActiveField
	};
};

export default useService;
